<template>
  <div class="container">
    <h1 class="text-center text-white d-none d-lg-block">
      Doe mee aan dé commercialcompetitie!
    </h1>
    <hr class="d-none d-lg-block"/>
    <div class="row flex-column-reverse flex-lg-row">
      <div class="col-lg-4">
        <div
          class="card bg-cr-red-black mb-3"
          :style="{'min-height': `${paneHeight}px`}"
        >
          <div class="card-body text-center text-white">
            <div>
              <p>
                Is jullie commercial de beste van het kwartaal? Op commercialreview.nl laten we
                Nederland elk kwartaal kiezen wat de best scorende commercials, verdeeld over zes
                categorieën, zijn.
              </p>

              <p class="mb-5">
                Meld je commercial aan voor dé commercialcompetitie en maak elk kwartaal kans op 1
                van de titels!
              </p>

              <div
                class="card card-body card-logo
                 d-flex align-items-center justify-content-center mb-3"
              >
                <img
                  class="img-logo"
                  src="@/common/assets/img/screenforce-logo.jpeg"
                  alt="screenforce"
                />
              </div>

              <div
                class="card card-body card-logo
                 d-flex align-items-center justify-content-center"
              >
                <img
                  class="img-logo"
                  src="@/common/assets/img/logo.png"
                  alt="commercialreview"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 mb-3">
        <v-register-commercial-card
          research-type="competition"
          title="Commercialcompetitie"
          color="cr-red-black"
          :price="BASE_PRICES.competition"
          icon="trophy"
          @research-type-selected="goToWizard()"
          :collapsed="true"
          ref="pane"
          button-text="word.register*"
          :hide-price="true"
        >
          <template slot="subtitle">
            Is je commercial <strong>de beste van het kwartaal</strong>? Doe nu mee!
          </template>
          <template slot="content">
            <div class="pb-0 text-left">
              <v-check-six-categories />
              <hr/>
              <v-check-winner-exposed />
              <hr/>
              <v-check-commercial-questions
                commercial-type="tv"
                research-type="competition"
              />
              <hr />
              <v-check-add-custom-question />
              <hr />
            </div>
            <v-collapse-transition>
              <div class="pt-0 text-left" v-if="showCompetitionInfo">
                <v-check-number-of-reviewers />
                <hr />
                <v-check-pdf-report />
                <hr/>
                <v-check-commercial-dashboard />
                <hr/>
                <v-check-csv-export />
                <hr/>
                <v-check-commercial-promoted />
              </div>
            </v-collapse-transition>

            <div class="d-flex flex-column align-items-center">
              <v-button
                size="xs"
                :icon="showCompetitionInfo ? 'times': 'info'"
                style-type="dark"
                :text="showCompetitionInfo ? 'phrase.less_info': 'phrase.show_all_advantages'"
                @click="showCompetitionInfo = !showCompetitionInfo"
              />
              <div class="w-100 text-right">
                <small>*Aanmelden kan vanaf &euro; {{ BASE_PRICES.competition }},-</small>
              </div>
            </div>
          </template>
        </v-register-commercial-card>
      </div>
    </div>

    <div class="mb-3">
      <v-partner-carousel/>
    </div>

    <v-auth-modal
      v-if="showAuthModal"
      sub-title="sentence.login_to_register_commercial"
      :title="`word.competition`"
      :closable="true"
      :as-organisation="true"
      @authenticated="goToRegisterCommercial"
      @hide-modal="showAuthModal = false"
    />
  </div>
</template>

<script>
import { BASE_PRICES } from '@/common/utils/constants';
import Button from '@/common/components/Button.vue';
import PartnerCarousel from '@/common/components/carousels/PartnerCarousel.vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import { notify } from '@/common/utils/notify';
import AuthModal from '@/common/components/auth/AuthModal.vue';
import { mapGetters } from 'vuex';
import AddCustomQuestion from '@/common/components/registration/AddCustomQuestion.vue';
import CommercialQuestions from '@/common/components/registration/CommercialQuestions.vue';
import CheckSixCategories from '@/common/components/registration/SixCategories.vue';
import CommercialDashboard from '@/common/components/registration/CommercialDashboard.vue';
import CsvExport from '@/common/components/registration/CsvExport.vue';
import NumberOfReviewers from '@/common/components/registration/NumberOfReviewers.vue';
import PdfReport from '@/common/components/registration/PdfReport.vue';
import WinnerExposed from '@/common/components/registration/WinnersExposed.vue';
import CommercialPromoted from '@/common/components/registration/CommercialPromoted.vue';
import RegisterCommercialCard from '@/common/components/registration/RegisterCommercialCard.vue';

export default {
  name: 'RegisterCommercialCompetition',
  components: {
    'v-auth-modal': AuthModal,
    'v-button': Button,
    'v-check-add-custom-question': AddCustomQuestion,
    'v-check-commercial-questions': CommercialQuestions,
    'v-check-commercial-dashboard': CommercialDashboard,
    'v-check-commercial-promoted': CommercialPromoted,
    'v-check-number-of-reviewers': NumberOfReviewers,
    'v-check-pdf-report': PdfReport,
    'v-check-six-categories': CheckSixCategories,
    'v-check-winner-exposed': WinnerExposed,
    'v-check-csv-export': CsvExport,
    'v-collapse-transition': CollapseTransition,
    'v-partner-carousel': PartnerCarousel,
    'v-register-commercial-card': RegisterCommercialCard,
  },
  data() {
    return {
      BASE_PRICES,
      showCompetitionInfo: false,
      showAuthModal: false,
      paneHeight: 0,
    };
  },
  computed: {
    ...mapGetters(['user', 'org']),
  },
  methods: {
    goToWizard() {
      if (this.user.isAuthenticated) {
        this.$router.push({
          name: 'organisation-register-commercial',
          params: { researchType: 'competition', commercialType: 'tv' },
        });
      } else {
        this.showAuthModal = true;
      }
    },
    goToRegisterCommercial() {
      notify('phrase.logged_in', 'sentence.register_commercial');
      this.$router.push({
        name: 'organisation-register-commercial',
        params: {
          commercialType: 'tv',
          researchType: 'competition',
        },
      });
    },
  },
  mounted() {
    if (window.innerWidth > 991) {
      this.paneHeight = this.$refs.pane.$refs.pane.clientHeight;
    }

    if (this.$route.query.utm_source) {
      sessionStorage.setItem('regSource', this.$route.query.utm_source);
    }
  },
};
</script>


<style>
.img-logo {
  height: 66px;
  width: auto;
}

.card-logo {
  min-height: 120px;
}

.icon-deal {
  font-size: 80px;
}
</style>
